// Manual Check-in for non-OE visits, decided on the site's calendar day.

import { getCurrentTimeInTimezone } from 'common/services/dateService'
import { PATIENT_STATUSES } from 'features/Home/constants/infoConstants'
import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

// A naive day, optionally with a naive clock; a zone or offset would make the digits another zone's.
const NAIVE_DAY = /^(\d{4}-\d{2}-\d{2})(?:[T ]\d{2}:\d{2}(?::\d{2})?)?$/

const EMR_ZERO_DATE = '0000-00-00'

// The appointment's own calendar digits; the payload files it under the site's day.
export const appointmentDay = (appointment: IPatientSchedule | undefined): string | null => {
  const day = appointment?.date?.match(NAIVE_DAY)?.[1] ?? null
  return day === EMR_ZERO_DATE ? null : day
}

// Same rule as v1: a code, not checked out, and not a future day on the site's calendar.
export const canManualCheckIn = (
  appointment: IPatientSchedule | undefined,
  timeZone: string | undefined,
): boolean => {
  const day = appointmentDay(appointment)
  if (!timeZone || !day || !appointment?.access_code) return false
  if (appointment.status?.code === PATIENT_STATUSES.CHECKED_OUT) return false

  return day <= getCurrentTimeInTimezone(timeZone).format('YYYY-MM-DD')
}
